import styled from 'styled-components';
import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Text = styled(TextLayoutComponent)`
  font-size: 16px;
  color: ${(props) => props.theme.color.textSecondary};
  ;
  ${(props) => props.brspace && 'margin-bottom: 1em;'}
`;
